import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHasPermission } from "../../../../hooks/useHasPermission";
import { startUIShowModulesCount } from "../../../../redux/actions/administrador/ui/ui";
import { IconApp } from "../../../IconApp";
import { NavLinkApp } from "../../../NavLinkApp";
import SidebarNavAccordion from "../../../SidebarNavAccordion";

export const Modules_Graduations_EAD = () => {
    const dispatch = useDispatch();
    const { hasPermission } = useHasPermission();
    const { color_text_menu_accordion } = useSelector((state) => state.config);

    const canShowAccordion = hasPermission([
        "GRADUATIONS_EAD_REQUESTS",
        "GRADUATIONS_EAD_REQUESTS_DATES_READ",
    ]);

    useEffect(() => {
        if (canShowAccordion) {
            dispatch(startUIShowModulesCount("Modules_Graduations_EAD"));
        }
    }, [canShowAccordion]);

    return (
        <div>
            {true && (
                <SidebarNavAccordion
                    title={"Titulaciones"}
                    itemLevel={0}
                    color={color_text_menu_accordion}
                    iconLeftClassName="fa-solid fa-solid fa-graduation-cap fa-xl"
                >
                    {hasPermission([
                        "GRADUATIONS_EAD_REQUESTS",
                        "GRADUATIONS_EAD_REQUESTS_DATES_READ",
                    ]) && (
                        <SidebarNavAccordion
                            title={"Opciones de titulación"}
                            itemLevel={1}
                            color={color_text_menu_accordion}
                            iconLeftClassName={
                                "fa-solid fa-code-branch fa-xl me-2"
                            }
                        >
                            {hasPermission([
                                "GRADUATIONS_EAD_REQUESTS_DATES_READ",
                            ]) && (
                                <NavLinkApp
                                    name="Fechas de apertura"
                                    to="/app/graduations-ead/requests/dates"
                                    icon={
                                        <IconApp iconClassName="fas fa-calendar-alt c-sidebar-nav-icon"></IconApp>
                                    }
                                />
                            )}

                            {hasPermission(["GRADUATIONS_EAD_REQUESTS"]) && (
                                <NavLinkApp
                                    name="Solicitudes"
                                    to="/app/graduations-ead/requests"
                                    icon={
                                        <IconApp iconClassName="fas fa-clipboard-list-check c-sidebar-nav-icon"></IconApp>
                                    }
                                />
                            )}
                        </SidebarNavAccordion>
                    )}
                    {/* Cuando haya más de un elemento, eliminar este que tiene el permiso "test" */}
                    {hasPermission("test") && (
                        <div>
                            <NavLinkApp
                                name="Opciones de titulación"
                                to="/app/graduations-ead/requests"
                                icon={
                                    <IconApp iconClassName="fas fa-code-branch c-sidebar-nav-icon"></IconApp>
                                }
                            />
                        </div>
                    )}
                </SidebarNavAccordion>
            )}
        </div>
    );
};
